import gql from 'graphql-tag';

export const DEAL_CONTACTS = gql`
  query DealContacts {
    dealActivity {
      dealContacts {
        label
        value
      }
    }
  }
`;
